const UserInfo = {
  components: {
    'uploader-avatar': UploaderAvatar,
  },
  data: function () {
    return {
      loading: false,
    };
  },
  computed: {
    ...Vuex.mapState(['user']),
  },
  watch: {
    'user.avatar'(avatar, old) {
      if (!old) return;
      let user = domestiko.user;
      user.avatar = avatar.url;
      domestiko.login(user);
    },
    'user.username'(username, old) {
      if (!old) return;
      let user = domestiko.user;
      user.username = username;
      domestiko.login(user);
    },
  },
  methods: {
    submit: function () {
      this.loading = true;
      axios
        .post('/usuarios/datos/', {
          id: this.user._id,
          username: this.user.username,
        })
        .then((res) => {
          customAlert(
            'Cuenta actualizada.',
            'Tus datos se han guardado con éxito.',
          );
        })
        .catch((err) => {
          console.log('Request KO!', err.response);
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
  template: `
      <div class="user-info">
      <div class="uk-grid">
        <div class="uk-width-1-2@m">
          <h4>Imagen de perfil</h4>
          <div class="uk-text-center">
            <uploader-avatar
              v-model="user.avatar"
              endpoint="/usuarios/avatar"
            ></uploader-avatar>
            <p>
              Pincha en la imagen para cambiarla.
              <a href="#undefined" class="icon-info">
              </a>
            </p>
          </div>
        </div>
        <div class="uk-width-1-2@m">
          <h4>Nombre</h4>
          <div class="uk-form-controls uk-margin-top">
            <input
              type="text" class="uk-input"
              v-model.lazy="user.username"
            />
          </div>
          <span class="uk-text-warning" v-if="!user.username">
            Por favor rellena tu nombre completo
          </span>
          <div class="uk-text-right uk-margin-top">
            <button
              @click="submit()"
              class="uk-button uk-button-dmtk"
            >Actualizar</button>
          </div>
        </div>
      </div>
      </div>
	`,
};
